//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import React, { useEffect, useState, useRef } from "react";
import styles from "../assets/styles/ClientDropdown.module.css";
import dropArrow from '../assets/images/dropArrow.png'
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

const ClientDropdown = ({ setMask, mask, data, selectedItem, setSelectedItem,bill }) => {
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const options = data;
  const dropdownRef = useRef(null);
  //--------------------------------------------------------------------All Variables---------------------------------------------------------------------------//

  //---------------------------------------------------------UseEffect to set Selected Item-----------------------------------------------------------------------//

  useEffect(() => {!mask && setShow(false); }, [mask]);
  useEffect(() => { if (!show) setSearch(""); }, [show]);
  function onItemClick(val) {
    setSelectedItem(val);
    setShow(false);
    setMask(false);
    setSearch("");
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);
  //---------------------------------------------------------UseEffect to set Selected Item-----------------------------------------------------------------------//

  return (
    <div className={styles.mainwidth} ref={dropdownRef}>
      <div className={styles.dropdownDisplay} role="button" onClick={() => {
          setShow((val)=>!val);
          setMask(true);
        }}>
        <div className={styles.dropdownnname}>
          <p className={styles.dropheadingtext}> {selectedItem?.Firstname ? selectedItem?.Firstname + " " + selectedItem?.Lastname : "Select a client"} </p>
          <img src={dropArrow} alt="" className={styles.rupeeSize}></img>
        </div>
      </div>
      {show && (
        <div className={bill?styles["dropContBill"]:styles["dropCont"]}>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Type to search..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
          {(options?.filter(val => {
            const fullName = `${val?.Firstname || ''} ${val?.Lastname || ''} ${val?.EmailId || ''}`.toLowerCase();
            return fullName.includes(search.toLowerCase());
          }) || []).length > 0 ? (
            options
              .filter(val => {
                const fullName = `${val?.Firstname || ''} ${val?.Lastname || ''} ${val?.EmailId || ''}`.toLowerCase();
                return fullName.includes(search.toLowerCase());
              })
              .map((val, i) => (
                <a key={String(i)} onClick={() => { onItemClick(val); }} className={styles["items"]}
                  style={{ backgroundColor: val === selectedItem ? "#E6F8F1" : "transparent" }} >
                  {val?.Firstname} {val?.Lastname} ({val?.EmailId})
                </a>
              ))
          ) : (
            <div className={styles.noResults}>No results found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClientDropdown;
